export default "__VITE_ASSET__fvqV4$Sd__"